import React, { useContext, createContext, useState, ReactNode } from "react";
import { useDisclosure } from "@chakra-ui/hooks";
import { Modal } from "components";

type ModalContextType = {
  isModalOpen: boolean;
  closeModal: () => void;
  openModal: () => void;
  setContent: (node: ReactNode) => void;
  setTitle: (title: string) => void;
};

const ModalContext = createContext<ModalContextType | undefined>(undefined);

export const useModal = () => useContext(ModalContext);

type Props = {
  children: ReactNode;
};

export const ModalProvider: React.FC<Props> = ({ children }: Props) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [content, setContent] = useState<ReactNode>(null);
  const [title, setTitle] = useState("");

  const isModalOpen = isOpen;
  const closeModal = onClose;
  const openModal = onOpen;

  return (
    <ModalContext.Provider
      value={{ isModalOpen, closeModal, openModal, setContent, setTitle }}
    >
      <Modal title={title} isOpen={isOpen} onClose={onClose}>
        {content}
      </Modal>
      {children}
    </ModalContext.Provider>
  );
};

export default ModalProvider;
